import { render } from "./ClientDeleteFormModal.vue?vue&type=template&id=408ae688&lang=pug"
import script from "./ClientDeleteFormModal.vue?vue&type=script&lang=ts"
export * from "./ClientDeleteFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script